import './App.css';
import SeleccionTema from './SeleccionTema';
import EnlaceTemas from './EnlaceTemas';
import Problema from './Problema';
import { useState } from 'react';
import  lecciones  from './lecciones/listalecciones';
function App() {


  const [leccionSeleccionada, setLeccionSeleccionada] = useState(lecciones[0]);
  const [codigoSeleccionada, setcodigoSeleccionada] = useState(0);
  const [leccionMostrar, setleccionMostrar] = useState(lecciones[0].titulo)

  function seleccionar(e) {
    lecciones.forEach((elemento, indice) => {
      if (elemento.titulo === e.target.value) {
        setLeccionSeleccionada(lecciones[indice])
        setcodigoSeleccionada(indice)
        setleccionMostrar(lecciones[indice].titulo)
      }
    });
  }

  function siguienteTema() {
    if (codigoSeleccionada < lecciones.length - 1) {
      window.scrollTo(0,0)      
      setcodigoSeleccionada(codigoSeleccionada + 1)
      setLeccionSeleccionada(lecciones[codigoSeleccionada+1])
      setleccionMostrar(lecciones[codigoSeleccionada+1].titulo)
    } else {
      alert('No hay más')
    }
  }

  function borrar() {
    if (window.confirm('¿Está seguro de borrar todos los ejercicios resueltos hasta ahora?')) {
      localStorage.clear();
      window.location.reload(false)
    }
  }


  return (
    <>
      <div className="contenedor">
        <EnlaceTemas></EnlaceTemas>
        <SeleccionTema lecciones={lecciones} onCambiar={seleccionar} onLeccionASeleccionar={leccionMostrar}></SeleccionTema>
        {leccionSeleccionada.problemas.map((problema) => {
          return (<Problema descripcion={problema.descripcion}
            programa={problema.programa}
            solucion={problema.solucion}
            codigo={problema.codigo.toString() + leccionSeleccionada.titulo}
            key={problema.codigo.toString() + leccionSeleccionada.titulo}></Problema>)
        })}
        <div className="avance">
          <button onClick={siguienteTema} className="botonavance">Siguiente práctica</button>
        </div>
        <button className="borrar-progresos" onClick={() => { borrar() }}>Borrar todos los progresos (cuidado)</button>
        <hr />
        <a href='https://www.tutorialesprogramacionya.com/'>Tutoriales Programación Ya</a>
      </div>
    </>
  );
}

export default App;
